// modules
import { useCallback, useState } from "react";

export type LocationState = {
	state: {
		secretCode: string;
		userName: string;
		type: string;
	};
};

export function useLoginVerification() {
	const [otpString, setOTPString] = useState<string>("");
	const [fieldErrs, setFieldErrs] = useState<{ totp: boolean }>({ totp: false });

	const handleOTPStringChange = useCallback(
		(val: string) => {
			setFieldErrs({ totp: false });
			setOTPString(val);
		},
		[fieldErrs, otpString]
	);

	const validateTOTPString = useCallback(() => {
		if (!otpString || otpString?.length !== 6) {
			setFieldErrs({ totp: true });
		}
	}, [otpString, fieldErrs]);

	return {
		otpString,
		fieldErrs,
		validateTOTPString,
		setFieldErrs,
		setOTPString: handleOTPStringChange
	};
}
